import { useEffect, useRef, useState } from "react";

export function useTextTruncation(deps = [], options = {}) {
  const { disabled = false } = options;
  const ref = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);
  const dependencyKey = JSON.stringify(deps);

  useEffect(() => {
    if (disabled || typeof window === "undefined") {
      return undefined;
    }

    const element = ref.current;
    if (!element) {
      return undefined;
    }

    let frameId = null;

    const measure = () => {
      frameId = null;
      setIsTruncated(
        element.scrollHeight > element.clientHeight + 1 ||
        element.scrollWidth > element.clientWidth + 1
      );
    };

    const queueMeasure = () => {
      if (frameId !== null) {
        return;
      }
      frameId = window.requestAnimationFrame(measure);
    };

    queueMeasure();

    const resizeObserver = "ResizeObserver" in window
      ? new ResizeObserver(queueMeasure)
      : null;

    resizeObserver?.observe(element);
    window.addEventListener("resize", queueMeasure);

    return () => {
      window.removeEventListener("resize", queueMeasure);
      resizeObserver?.disconnect();
      if (frameId !== null) {
        window.cancelAnimationFrame(frameId);
      }
    };
  }, [dependencyKey, disabled]);

  return { ref, isTruncated };
}
